
import { ProPageHeader } from "./ProPageHeader";
import { ProFeatures } from "./ProFeatures";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { TrustBadges } from "@/components/TrustBadges";
import { PricingComparison } from "@/components/PricingComparison";
import { FAQ } from "@/components/FAQ";
import { ExitIntentPopup } from "@/components/ExitIntentPopup";
import { WaitlistForm } from "@/components/shared/WaitlistForm";

interface ProPageContentProps {
  showWaitlist: boolean;
  setShowWaitlist: (show: boolean) => void;
}

const features = [
  {
    title: "Visibilité Maximale",
    description: "Soyez visible auprès d'une clientèle locale et touristique qualifiée"
  },
  {
    title: "Gestion Simplifiée",
    description: "Gérez vos réservations et votre planning en quelques clics"
  },
  {
    title: "0% Commission",
    description: "Gardez 100% de vos revenus, sans frais cachés"
  }
];

export const ProPageContent = ({
  showWaitlist,
  setShowWaitlist
}: ProPageContentProps) => {
  return (
    <div className="flex-grow">
      <section className="py-16 px-4">
        <ProPageHeader onShowWaitlist={() => setShowWaitlist(true)} />
        <ProFeatures features={features} />
      </section>

      <WhyChooseUs isPro={true} />
      <TrustBadges isPro={true} />
      <PricingComparison />
      <FAQ isPro={true} />
      <ExitIntentPopup />
      
      <WaitlistForm 
        isPro={true}
        open={showWaitlist}
        onOpenChange={setShowWaitlist}
      />
    </div>
  );
};
